import React, { useEffect, useContext } from 'react';
import { store } from './store';
import { useHistory } from 'react-router-dom';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

import CardSection from './CardSection';

function PaymentForm({ id, onValid, registerOnPayHandler }) {
	const stripe = useStripe();
	const elements = useElements();
	const history = useHistory();
	const { dispatch } = useContext(store);

	if (elements) {
		const cardElement = elements.getElement(CardElement);
		if (cardElement) {
			cardElement.on('change', function (event) {
				//var displayError = document.getElementById('card-errors');
				const isValid = event.complete;
				if (event.error) {
					onValid(isValid);
					//	displayError.textContent = event.error.message;
				} else {
					onValid(isValid);
					//	displayError.textContent = '';
				}
			});
		}
	}

	const handleSubmit = async ({ state, nameOnCard, zip, email, secret }) => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		//event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			dispatch({ type: 'stop processing payment' });
			return;
		}

		if (state.payment.retry >= 2) {
			// Third failed attempt: give up without charging the card. Stay in
			// the Account tab so the error is visible (pushing '/' bounced
			// appboard to the Dashboard and hid this widget).
			dispatch({ type: 'payment retry reset' });
			dispatch({ type: 'stop processing payment' });
			dispatch({
				type: 'post error',
				e: 'Please check your card and try again. Thank you!'
			});
			history.push('/account/invoices/list');
			return;
		}
		dispatch({ type: 'payment retry increment' });

		const data = {
			payment_method: {
				card: elements.getElement(CardElement),
				billing_details: {
					name: nameOnCard,
					email,
					address: {
						postal_code: zip
					}
				}
			}
		};

		const result = await stripe.confirmCardPayment(`${secret}`, data);
		dispatch({ type: 'stop processing payment' });
		if (result.error) {
			dispatch({ type: 'post error', e: result.error });
		} else {
			// The payment has been processed!
			const {
				paymentIntent: { status, id }
			} = result;
			console.log('result', result);
			if (status === 'succeeded') {
				dispatch({ type: 'payment retry reset' });
				history.push(`/account/pay/success/receipt/${id}`, result);
			}
		}
	};

	useEffect(() => {
		if (elements) {
			registerOnPayHandler(handleSubmit);
		}
	}, [elements]);

	return <CardSection />;
}
export default PaymentForm;
